import { render } from "./CardStats.vue?vue&type=template&id=48551b4a"
import script from "./CardStats.vue?vue&type=script&lang=js"
export * from "./CardStats.vue?vue&type=script&lang=js"
script.render = render

export default script